import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyFeedbackAnalysisDiscoveryDialog: LoadableType<{
	onClose: () => void;
	onCloseComplete: () => void;
	publishedPageTitle: string;
	spaceName: string;
	spaceKey?: string;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FeedbackAnalysisDiscoveryDialog" */ '../src/rovo/FeedbackAnalysisDialog.tsx'
			)
		).FeedbackAnalysisDialog,
});
